import { render, staticRenderFns } from "./exchangeItemForm.vue?vue&type=template&id=6d1f9154&scoped=true&"
import script from "./exchangeItemForm.vue?vue&type=script&lang=js&"
export * from "./exchangeItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f9154",
  null
  
)

export default component.exports